import { TableHeader } from "@/models/TableHeader";

export const facilityReviewsHeaders: TableHeader[] = [
  {
    text: "First Name",
    value: "first_name",
    width: "10rem"
  },
  {
    text: "Last Name",
    value: "last_name",
    width: "10rem"
  }, {
    text: "Email",
    value: "email",
    width: "18rem"
  },
  {
    text: "Rating",
    value: "rating",
    width: "5.5rem"
  },
  {
    text: "Featured",
    value: "featured_on_homepage",
    width: "6.5rem"
  },
  {
    text: "Preview",
    value: "content",
    width: "28rem"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
